/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/11/2023.
 */

import appConfig from "../../../appConfig";

/**
 * This is a reducer for the current organization.
 */

const getDomain = (model) => {
  switch (model.domain_type) {
    case "default":
      return appConfig.defaultPublicDomain;
    case "subdomain":
      return model.subdomain;

    case "custom":
    // TBD what to do when the DNS not verified?
  }
};

const initialState = {
  model: null,
  domain: "",
  subscription: null,
  subscriptionCredits: null,
  credits: null,
  billing: null,

  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  edit: false,
  editSuccess: false,
  editError: null,

  billingFetch: false,
  billingFetchSuccess: false,
  billingFetchError: false,

  activateTrial: false,
  activateTrialSuccess: false,
  activateTrialError: null,

  activateFreePlan: false,
  activateFreePlanSuccess: false,
  activateFreePlanError: null,

  updateSetting: false,
  updateSettingSuccess: false,
  updateSettingError: null,

  updateDomain: false,
  updateDomainSuccess: false,
  updateDomainError: null,

  deleteOrganization: false,
  deleteOrganizationSuccess: false,
  deleteOrganizationError: null,

  refreshDNSStatus: false,
  refreshDNSStatusSuccess: false,
  refreshDNSStatusError: null,

  regenerateCertificate: false,
  regenerateCertificateSuccess: false,
  regenerateCertificateError: null,

  // Keyed by branding file type ("logo" | "favicon") so the two uploads
  // can be in flight/failed independently.
  uploadBrandingFile: {},
  uploadBrandingFileError: {},
};

export default function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case "USER_CHECK_SESSION":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null,
      };

    case "USER_CHECK_SESSION_FULFILLED":
    case "USER_LOGIN_FULFILLED":
    case "USER_ACTIVATE_PENDING_ACCOUNT_FULFILLED":
    case "USER_SWITCH_ORG_FULFILLED":
    case "USER_REGISTER_FULFILLED":
      return {
        ...state,
        model: action.payload.organization,
        subscription: action.payload.plan,
        domain: getDomain(action.payload.organization),
        fetch: false,
        fetchSuccess: true,
        fetchError: null,
      };

    case "USER_CHECK_SESSION_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: action.payload,
      };

    case "USER_AUTOLOGIN_FULFILLED":
      return {
        ...state,
        model: action.payload.organization,
        subscription: action.payload.plan,
      };

    case "USER_AUTOLOGOUT":
      return {
        ...state,
        model: action.payload.currentOrganization.model,
        subscription: action.payload.currentOrganization.subscription,
      };

    // TODO how to distinguish current organization from admin-edited organization? isAdminEdit?
    case "ORGANIZATION_EDIT":
      return action.isAdminEdit
        ? state
        : { ...state, edit: true, editSuccess: false, editError: null };

    case "ORGANIZATION_EDIT_FULFILLED":
      return action.isAdminEdit
        ? state
        : {
            ...state,
            model: { ...state.model, ...action.payload },
            edit: false,
            editSuccess: true,
          };

    case "ORGANIZATION_EDIT_REJECTED":
      return {
        ...state,
        edit: false,
        editError: action.payload,
      };

    case "UPLOAD_BRANDING_FILE":
      return {
        ...state,
        uploadBrandingFile: { ...state.uploadBrandingFile, [action.fileType]: true },
        uploadBrandingFileError: { ...state.uploadBrandingFileError, [action.fileType]: null },
      };

    case "UPLOAD_BRANDING_FILE_FULFILLED":
      return {
        ...state,
        model: { ...state.model, ...action.payload },
        uploadBrandingFile: { ...state.uploadBrandingFile, [action.fileType]: false },
      };

    case "UPLOAD_BRANDING_FILE_REJECTED":
      return {
        ...state,
        uploadBrandingFile: { ...state.uploadBrandingFile, [action.fileType]: false },
        uploadBrandingFileError: { ...state.uploadBrandingFileError, [action.fileType]: action.payload },
      };

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        model: state.model,
        subscription: state.subscription,
        credits: state.credits,
        subscriptionCredits: state.subscriptionCredits,
        billing: state.billing,
        updateDomainError: null,
      };

    case "BILLING_HISTORY_FETCH":
      return {
        ...state,
        billingFetch: true,
        billingFetchSuccess: false,
        billingFetchError: null,
      };

    case "BILLING_HISTORY_FETCH_FULFILLED":
      return {
        ...state,
        billingFetch: false,
        billingFetchSuccess: true,
        billing: action.payload,
      };

    case "BILLING_HISTORY_FETCH_REJECTED":
      return {
        ...state,
        billingFetch: false,
        billingFetchError: action.payload,
      };

    case "SUBSCRIPTION_CREDITS_FETCH_FULFILLED":
      return {
        ...state,
        subscriptionCredits: action.payload
          ? action.payload.currentPeriodCredits
          : 0,
        credits: action.payload,
      };

    case "SUBSCRIPTION_INITIATE_FULFILLED":
      return {
        ...state,
        model: {
          ...state.model,
          pending_payment: 1,
        },
      };

    // update model.widgets_usage depending on available = 1 or 0 (add or subtract)
    case "CALENDAR_UPDATE_FULFILLED":
    case "GROUP_UPDATE_FULFILLED":
    case "WIDGET_UPDATE_FULFILLED":
    case "ALERT_UPDATE_FULFILLED":
      if (action.payload.available === 1 && !action.previousAvailable) {
        return {
          ...state,
          model: {
            ...state.model,
            usage: {
              ...state.model.usage,
              widgets: state.model.usage.widgets + 1,
            },
          },
        };
      } else if (action.payload.available === 0 && action.previousAvailable) {
        return {
          ...state,
          model: {
            ...state.model,
            usage: {
              ...state.model.usage,
              widgets: state.model.usage.widgets - 1,
            },
          },
        };
      }
      return state;

    case "DOMAIN_DELETE_FULFILLED":
      return {
        ...state,
        model: {
          ...state.model,
          usage: {
            ...state.model.usage,
            domains: state.model.usage.domains - 1,
          },
        },
      };

    case "DOMAIN_UPDATE_FULFILLED":
      if (action.payload.available === 1) {
        return {
          ...state,
          model: {
            ...state.model,
            usage: {
              ...state.model.usage,
              domains: state.model.usage.domains + 1,
            },
          },
        };
      } else if (action.payload.available === 0) {
        return {
          ...state,
          model: {
            ...state.model,
            usage: {
              ...state.model.usage,
              domains: state.model.usage.domains - 1,
            },
          },
        };
      }
      return state;

    case "ORGANIZATION_ACTIVATE_TRIAL":
      return {
        ...state,
        activateTrial: true,
        activateTrialSuccess: false,
        activateTrialError: null,
      };

    case "ORGANIZATION_ACTIVATE_TRIAL_FULFILLED":
      return {
        ...state,
        activateTrial: false,
        activateTrialSuccess: true,
      };

    case "ORGANIZATION_ACTIVATE_TRIAL_REJECTED":
      return {
        ...state,
        activateTrial: false,
        activateTrialSuccess: false,
        activateTrialError: action.payload,
      };

    case "ORGANIZATION_ACTIVATE_FREE_PLAN":
      return {
        ...state,
        activateFreePlan: true,
        activateFreePlanSuccess: false,
        activateFreePlanError: null,
      };

    case "ORGANIZATION_ACTIVATE_FREE_PLAN_FULFILLED":
      return {
        ...state,
        activateFreePlan: false,
        activateFreePlanSuccess: true,
      };

    case "ORGANIZATION_ACTIVATE_FREE_PLAN_REJECTED":
      return {
        ...state,
        activateFreePlan: false,
        activateFreePlanSuccess: false,
        activateFreePlanError: action.payload,
      };

    case "ORGANIZATION_UPDATE_SETTING":
      return {
        ...state,
        updateSetting: true,
        updateSettingSuccess: false,
        updateSettingError: null,
      };

    case "ORGANIZATION_UPDATE_SETTING_FULFILLED":
      return {
        ...state,
        updateSetting: false,
        updateSettingSuccess: true,
        model: {
          ...state.model,
          organization_settings: action.payload,
        },
      };

    case "ORGANIZATION_UPDATE_SETTING_REJECTED":
      return {
        ...state,
        updateSetting: false,
        updateSettingSuccess: false,
        updateSettingError: action.payload,
      };

    case "ORGANIZATION_DELETE":
      return {
        ...state,
        deleteOrganization: true,
        deleteOrganizationSuccess: false,
        deleteOrganizationError: null,
      };

    case "ORGANIZATION_DELETE_FULFILLED":
      return {
        ...state,
        // collection: state.collection.find((i) => i.uuid !== action.uuid),
        deleteOrganization: false,
        deleteOrganizationSuccess: true,
      };

    case "ORGANIZATION_DELETE_REJECTED":
      return {
        ...state,
        deleteOrganization: false,
        deleteOrganizationError: action.payload,
      };

    case "ORGANIZATION_UPDATE_DOMAIN":
      return {
        ...state,
        updateDomain: true,
        updateDomainSuccess: false,
        updateDomainError: null,
      };

    case "ORGANIZATION_UPDATE_DOMAIN_FULFILLED":
      return {
        ...state,
        model: action.payload,
        domain: getDomain(action.payload),
        updateDomain: false,
        updateDomainSuccess: true,
      };

    case "ORGANIZATION_UPDATE_DOMAIN_REJECTED":
      return {
        ...state,
        updateDomain: false,
        updateDomainError: action.payload,
      };

    case "ORGANIZATION_DNS_REFRESH":
      return {
        ...state,
        refreshDNSStatus: true,
        refreshDNSStatusSuccess: false,
        refreshDNSStatusError: null,
      };

    case "ORGANIZATION_DNS_REFRESH_FULFILLED":
      return {
        ...state,
        model: action.payload,
        domain: getDomain(action.payload),
        refreshDNSStatus: false,
        refreshDNSStatusSuccess: true,
      };

    case "ORGANIZATION_DNS_REFRESH_REJECTED":
      return {
        ...state,
        refreshDNSStatus: false,
        refreshDNSStatusError: action.payload,
      };

    case "ORGANIZATION_CERT_REGENERATE":
      return {
        ...state,
        regenerateCertificate: true,
        regenerateCertificateSuccess: false,
        regenerateCertificateError: null,
      };

    case "ORGANIZATION_CERT_REGENERATE_FULFILLED":
      return {
        ...state,
        model: action.payload,
        domain: getDomain(action.payload),
        regenerateCertificate: false,
        regenerateCertificateSuccess: true,
      };

    case "ORGANIZATION_CERT_REGENERATE_REJECTED":
      return {
        ...state,
        regenerateCertificate: false,
        regenerateCertificateError: action.payload,
      };

    default:
      return state;
  }

  return state;
}
